import { render, staticRenderFns } from "./uploadCoupon.vue?vue&type=template&id=e2c4cb4e&scoped=true&"
import script from "./uploadCoupon.vue?vue&type=script&lang=js&"
export * from "./uploadCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4cb4e",
  null
  
)

export default component.exports